export class Sticky {

    constructor ( target = '.js-sticky', options = {} ) {
        this.target = target;

        this.offset = 60;
    }

    init () {
        this.header = document.querySelector( this.target );

        if ( ( window.scrollY > this.offset || window.pageYOffset > this.offset ) ) {
            this.header.classList.add( 'js-sticky--stuck' );
        }

        document.addEventListener( 'scroll', this.scrollEvent.bind(this), {
            capture: true,
            passive: true
        });
    }

    scrollEvent () {

        requestAnimationFrame( () => {

            if ( !this.header.classList.contains( 'js-sticky--stuck' ) && ( window.scrollY > this.offset || window.pageYOffset > this.offset ) ) {

                this.header.classList.add( 'js-sticky--stuck' );

            } else if ( ( window.scrollY < this.offset || window.pageYOffset < this.offset ) && this.header.classList.contains( 'js-sticky--stuck' ) ) {

                this.header.classList.remove( 'js-sticky--stuck' );

            }
        } );
    }

    destroy() {
        document.removeEventListener( 'scroll', this.scrollEvent.bind(this), {
            capture: true,
            passive: true
        });
    }
}
